import { render, staticRenderFns } from "./distribution-chart.component.vue?vue&type=template&id=184bd968&scoped=true"
import script from "./distribution-chart.component.vue?vue&type=script&lang=ts"
export * from "./distribution-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./distribution-chart.component.vue?vue&type=style&index=0&id=184bd968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184bd968",
  null
  
)

export default component.exports